// ForgotPassword.jsx
import React, { useState } from 'react';
import authService from '../services/auth.service'; 
import { useNavigate } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(""); 
  const [error, setError] = useState("");    
  
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");

    try {
      console.log("📨 Attempting to send reset link to:", email);
      
      // authService ka forgotPassword call kiya
      const response = await authService.forgotPassword(email);
      
      // Success logic
      setMessage(response.message || "Reset link aapki email par bhej di gayi hai!");
      
      // Optional: 3-4 second baad user ko login par wapas bhej sakte ho
      // setTimeout(() => navigate('/login'), 4000);

    } catch (err) {
      // Error logic
      setError(err.message || "Kuch galat hua. Please dobara koshish karein.");
      console.error("❌ Forgot Password UI Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="container-fluid vh-100 d-flex justify-content-center align-items-center bg-light">
  <div className="card border-0 shadow-lg" style={{ width: '100%', maxWidth: '420px', borderRadius: '15px' }}>
    <div className="card-body p-5">
      {/* Icon or Logo Placeholder */}
      <div className="text-center mb-4">
        <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px' }}>
          <i className="bi bi-shield-lock fs-2"></i> {/* Bootstrap Icon use kar sakte ho */}
          <span className="fs-2">🔑</span>
        </div>
      </div>

      <h3 className="fw-bold text-center mb-2" style={{ color: '#2d3748' }}>Forgot Password?</h3>
      <p className="text-muted text-center mb-4 small px-2">
        No worries! Enter your email below and we'll send you a secure link to reset your password.
      </p>

      {/* Custom Alert Styling */}
      {message && (
        <div className="alert alert-success border-0 shadow-sm small py-2 text-center mb-4" style={{ borderRadius: '8px' }}>
          <i className="bi bi-check-circle-fill me-2"></i> {message}
        </div>
      )}

      {error && (
        <div className="alert alert-danger border-0 shadow-sm small py-2 text-center mb-4" style={{ borderRadius: '8px' }}>
          <i className="bi bi-exclamation-triangle-fill me-2"></i> {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="needs-validation">
        <div className="mb-4">
          <label className="form-label fw-semibold small text-secondary">Email Address</label>
          <div className="input-group">
            <input
              type="email"
              className="form-control form-control-lg border-end-0"
              placeholder="name@example.com"
              style={{ borderRadius: '10px 0 0 10px', fontSize: '0.95rem', border: '1px solid #e2e8f0' }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              required
            />
            <span className="input-group-text bg-white border-start-0" style={{ borderRadius: '0 10px 10px 0', border: '1px solid #e2e8f0', color: '#a0aec0' }}>
              @
            </span>
          </div>
        </div>

        <button
          type="submit"
          className="btn btn-primary btn-lg w-100 fw-bold shadow-sm mb-3"
          style={{ borderRadius: '10px', transition: 'all 0.3s', backgroundColor: '#4a90e2', border: 'none' }}
          disabled={loading || !email}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2"></span>
              Sending Link...
            </>
          ) : (
            "Send Reset Link"
          )}
        </button>
      </form>

      <div className="text-center mt-2">
        <button
          className="btn btn-link btn-sm text-decoration-none fw-semibold text-secondary d-flex align-items-center justify-content-center mx-auto"
          onClick={() => navigate('/login')}
          style={{ transition: 'color 0.2s' }}
        >
          <span className="me-2">←</span> Back to Login
        </button>
      </div>
    </div>
  </div>
</div>
  );
};

export default ForgotPassword;